import React from 'react';
import './Main.css';

import { Routes, Route } from "react-router-dom";
import Contact from './Contact';
import HomePage from './HomePage';
import ReserveTable from './ReserveTable';

const Main = () => {
    return (
        <main className="main">
            <section className="main-content">
                <Routes>
                    <Route path="/" element={<HomePage />}></Route>
                    <Route path="/reserve" element={<ReserveTable />}></Route>
                    <Route path="/contact" element={<Contact />}></Route>
                </Routes>
            </section>
        </main>
    );
};

export default Main;